<template>
  <article class="learning-wrapper">
    <div class="container">
      <div class="text-wrapper">
        <div class="title">
          학습 강좌
          <span class="apply-cnt" v-show="mainInfo.limit_way === 'P'"
            >신청 인원: {{ totalstudent }}/{{ mainInfo.limit_num }}명</span
          >
          <span class="apply-cnt" v-show="compIsWaitShow"> | </span>
          <span v-show="compIsWaitShow" class="apply-cnt"
            >대기 인원: {{ totalwaitstudentcnt }}/{{
              mainInfo.wait_num
            }}명</span
          >
        </div>
        <ul class="sub">
          <li>
            * <span>수강신청 완료 후</span> 반드시
            <span>수강신청내역 확인을 진행</span>해주시기 바랍니다.
          </li>
          <li>
            * <span>수강 취소</span>를 원하시는 경우
            <span>수강신청 내역 확인 메뉴에서 진행</span>해주시기 바랍니다.
          </li>
        </ul>
      </div>
      <div class="select-wrapper">
        <multiselect
          class="select"
          v-model="selectModel"
          :options="compClassList"
          label="class_name"
          track-by="class_name"
          :show-labels="false"
          @select="dispatchAction"
        >
          <template #option="{ option }">
            <div class="list-item">
              <span class="option__title">{{ option.class_name }}</span>
            </div>
          </template>
        </multiselect>
        <p class="warn">
          *왼쪽 화살표(<span>&#9660;</span>)를 눌러 세부 강의를 확인해보세요.
        </p>
      </div>
      <ul class="list-wrapper">
        <li
          v-for="(sugangItem, sugangIndex) in suganglist"
          :key="'sugang' + sugangIndex"
          :class="sugangItem['checked'] ? 'on' : ''"
        >
          <div class="top-con">
            <p v-if="isWaitInfo === 'Y'">
              <span v-if="sugangItem.faNum !== 0 && sugangItem.faType === 'SF'">
                <span class="select-btn-default"> 모집 : {{ sugangItem.faNum }} </span>
                <span class="select-btn-red"> 잔여 : {{ sugangItem.faNum - sugangItem.applicantNum }} </span>
                <span>
                  <span v-if="sugangItem.waitingNum !== 0 && sugangItem.statusYCnt < sugangItem.waitingNum" class="select-btn-default">
                    대기 신청 가능
                    <span v-if="mainInfo.wait_num_YN === 'Y'"> (잔여: {{ sugangItem.waitingNum - sugangItem.statusYCnt }}명) </span>
                  </span>
                  <span v-else-if="sugangItem.waitingNum !== 0" class="select-btn-default">
                    대기인원 마감
                    <span v-if="mainInfo.wait_num_YN === 'Y'">(잔여: {{ sugangItem.waitingNum - sugangItem.statusYCnt }}명) </span>
                  </span>
                  <span v-else class="select-btn-default">대기 신청 불가능 </span>
                </span>
              </span>
            </p>
            <div class="class-detail">
              <div>
                <input
                  v-show="sugangItem['isActivate'] && sugangItem['isUse']"
                  class="select-check"
                  type="checkbox"
                  v-model="sugangItem.checked"
                  @change="onChangeClass(sugangItem)"
                />
                <p>{{ sugangItem.subjectName }}</p>
              </div>
              <p @click="clickDetail(sugangItem)">자세히 보기</p>
            </div>
          </div>
          <p class="bottom-con">{{ sugangItem.desc }}</p>
        </li>
      </ul>
    </div>
  </article>
  <ClassInfo
    :visible="classInfoModal"
    :classInfo="classDetailInfo"
    @closeModal="onClonseModal"
  ></ClassInfo>
</template>

<script>
import { ref } from "@vue/reactivity";
import { computed, onMounted, watch } from "@vue/runtime-core";
import _ from "lodash";

import ClassInfo from "@/components/global/ClassInfo.vue";
import store from "@/store";
export default {
  emits: ["changeClass", "selectItem"],
  props: {
    /*
     * @description : 과정 리스트
     */
    classList: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
    /**
     * @description : 수업 리스트
     */
    sugangList: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
    /**
     * @description : 나의 수업 리스트
     */
    studentSugangList: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
    /**
     * @description : 수업 정보
     */
    mainInfo: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    /**
     * @description : 프로그램 정보
     */
    program: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    /**
     * @description : 선택된 내역
     */
    selectList: {
      type: Object,
      required: false,
      default() {
        return [];
      },
    },
    /**
     * @description : 전체 수강생
     */
    totalstudent: {
      type: Number,
      required: false,
      default: 0,
    },
    /**
     * @description : 전체 대기수강생
     */
    totalwaitstudentcnt: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {
    ClassInfo,
  },
  setup(props, context) {
    const selectModel = ref({ class_name: "전체", idx: -999 });
    const selectIndex = ref(-1);
    const labelList = [
      { key: "language", value: "언어" },
      { key: "place", value: "장소" },
      { key: "day", value: "요일" },
      { key: "subjectStartTime", value: "교육시간" },
      { key: "eduPrice", value: "교육비" },
      { key: "bookPrice", value: "교재비" },
      { key: "level", value: "레벨" },
      { key: "teacher", value: "강사" },
    ];
    const suganglist = ref([]);
    const subDupType = ref("");
    const classInfoModal = ref(false);
    const classDetailInfo = ref([]);

    const isWaitInfo = store.getters.getisWaitInfo;
    let checkBoxCheckNum = 0;

    const dispatchAction = (val) => {
      context.emit("changeClass", val);
    };

    const compClassList = computed(() => {
      const clone = _.cloneDeep(props.classList);

      return clone;
    });

    onMounted(() => {
      initSugangList(props.sugangList);
    });

    //초기 수강신청 리스트 세팅
    const initSugangList = (cur) => {
      if (cur) {
        const clone = _.cloneDeep(cur);

        selectIndex.value = -1;

        clone.forEach((cloneItem) => {
          const { columnOrder } = cloneItem;
          const split = columnOrder.split("^");

          let temp = [];
          let descList = [];
          for (let i = 0; i < split.length; i++) {
            const find = labelList.find(
              (findItem) => findItem["value"] === split[i]
            );

            if (find) {
              //수업 및 일자는 별개 처리
              let str = "";
              if (find["value"] === "요일") {
                str = cloneItem[find["key"]].replaceAll("^", "");
              } else if (find["value"] === "교육시간") {
                str = `${cloneItem[find["key"]]}~${
                  cloneItem["subjectEndTime"]
                }`;
              } else if (find["value"] === "교육비") {
                // 교육비 표기 수정
                str = `${cloneItem[find["key"]]
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}원`;
              } else {
                str = cloneItem[find["key"]];
              }
              descList.push({
                title: find["value"],
                text: str,
              });
              temp.push(`${find["value"]}:${str}`);
            }
          }
          cloneItem["checked"] = false;
          cloneItem["isUse"] = true;
          cloneItem["desc"] = temp.join(" | ");
          //cloneItem['descList']
          //setDescList(cloneItem["desc"]);
          cloneItem["descList"] = descList;
          cloneItem["isMyClass"] = false;
          cloneItem["isActivate"] = true;
        });

        suganglist.value = clone;
      } else {
        suganglist.value = [];
      }
    };

    //나의 수업이 존재하는지 체크
    const exceptMyClass = (myclass) => {
      //수업 리스트
      for (
        let classIndex = 0;
        classIndex < suganglist.value.length;
        classIndex++
      ) {
        const item = suganglist.value[classIndex];

        const { subjectIdx } = item;
        let find = null;
        for (
          let myClassIndex = 0;
          myClassIndex < myclass.length;
          myClassIndex++
        ) {
          find = myclass.find(
            (myClassItem) =>
              Number(myClassItem["idxItmSugangSubject"]) === Number(subjectIdx)
          );
        }

        if (find) {
          item["isActivate"] = false;
          item["isMyClass"] = true;
        }
      }
    };

    // key를 중심으로 group by
    const groupBySugang = (list, key) => {
      const group = _.groupBy(list, (item) => item[key]);
      const arr = Object.keys(group).map((itemKey) => ({
        key: Number(itemKey),
        fatype: group[itemKey][0]["faType"],
        value: group[itemKey],
      }));
      return arr;
    };

    const sumCnt = (list) => {
      return _.sumBy(list, (item) => item["applicantNum"] + item["statusYCnt"]);
    };

    const sugangCourseListActivate = (idxItmSugangClassKey, value = false) => {
      const fil = suganglist.value.filter(
        (item) => item["idxItmSugangClass"] === idxItmSugangClassKey
      );

      fil.map((item) => (item["isActivate"] = value));
    };

    const sugangClassListAcivate = (value = []) => {
      for (let classIndex = 0; classIndex < value.length; classIndex++) {
        const sum =
          value[classIndex]["applicantNum"] + value[classIndex]["statusYCnt"];
        const isApplyCnt =
          value[classIndex]["faNum"] + value[classIndex]["waitingNum"];
        if (isApplyCnt <= sum) {
          value[classIndex]["isActivate"] = false;
        }
      }
    };

    //신청자수 제한 체크
    const applyLimitOption = () => {
      const { limit_way } = props.mainInfo;
      if (limit_way === "S") {
        //idxItmSugangClass 으로 Group By
        const groupByList = groupBySugang(
          suganglist.value,
          "idxItmSugangClass"
        );

        /**
         * faType : AF(클래스 전체 선착순)
         * faType : SF(클래스 별 선착순)
         * faType : N(제한없음)
         */
        for (
          let groupIndex = 0;
          groupIndex < groupByList.length;
          groupIndex++
        ) {
          const { fatype, value, key } = groupByList[groupIndex];
          const sum = sumCnt(value);

          if (fatype === "AF") {
            const isApplyCnt = value[0]["faNum"] + value[0]["waitingNum"];

            if (isApplyCnt <= sum) {
              sugangCourseListActivate(key, false);
            }
          } else if (fatype === "SF") {
            sugangClassListAcivate(value);
          }
        }

        //

        // for (let sugangIndex = 0; sugangIndex < suganglist.value.length; sugangIndex++) {

        //   /**
        //    * 모집 수강생 수 : faNum
        //    * 신청자 수강생 수 : applyCountNum
        //    * 대기 수강생 수: waitingNum
        //    * 과정 수강생 수 : statusYCnt
        //    */
        //   const { faType, applyCountNum, faNum, waitingNum, applicantNum } = suganglist.value[sugangIndex];
        //   //클래스 전체 선착순 curClassTotalApplyCnt
        //   const curClassTotalApplyCnt = applyCountNum + waitingNum;
        //   //클래스 별 선착순 curClassPerApplyCnt
        //   const curClassPerApplyCnt = applicantNum + waitingNum;
        //   if (faType === "AF" && curClassTotalApplyCnt === faNum) {
        //     suganglist.value[sugangIndex]["isActivate"] = false;
        //   } else if (faType === "SF" && curClassPerApplyCnt === faNum) {
        //     suganglist.value[sugangIndex]["isActivate"] = false;
        //   }
        // }
      }
    };

    // 프로그램별 선착순 제한
    const programLimitOption = () => {
      const { wait_YN, limit_way, limit_num, wait_num } = props.mainInfo;
      const { totalstudent, totalwaitstudentcnt } = props;
      if (limit_way === "P") {
        if (totalstudent >= limit_num) {
          if (wait_YN === "Y") {
            if (totalwaitstudentcnt >= wait_num) {
              allDisableSugangList();
            }
          } else if (wait_YN === "N") {
            allDisableSugangList();
          }
        }
      }
    };

    const allDisableSugangList = () => {
      suganglist.value.forEach((sugantItem) => {
        sugantItem["isActivate"] = false;
      });
    };

    const setProgrmaInfo = () => {
      //중복가능(A) , 과정 내 중복 가능 / 타 과정 중복 불가능(O),  중복 불가(X) ,과목 내 불가/타 과목 중복 가능(N)
      subDupType.value = props.program["subject_dup_type"];
    };

    //중복 타입 활성화 비활성화 처리
    const setDupType = () => {
      for (
        let selectIndex = 0;
        selectIndex < props.selectList.length;
        selectIndex++
      ) {
        const { checked, idxItmSugangClass, subjectIdx } =
          props.selectList[selectIndex];

        if (subDupType.value === "O") {
          for (let index = 0; index < suganglist.value.length; index++) {
            const sugangItem = suganglist.value[index];
            const { idxItmSugangClass: standardItmSugangClass, isActivate } =
              sugangItem;

            if (
              standardItmSugangClass !== idxItmSugangClass &&
              isActivate &&
              !sugangItem["checked"]
            ) {
              sugangItem["isUse"] = !checked;
            }
          }
        } else if (subDupType.value === "X") {
          for (let index = 0; index < suganglist.value.length; index++) {
            const sugangItem = suganglist.value[index];
            const { subjectIdx: standardSubjectIdx, isActivate } = sugangItem;

            if (
              subjectIdx !== standardSubjectIdx &&
              isActivate &&
              !sugangItem["checked"]
            ) {
              sugangItem["isUse"] = !checked;
            }
          }
        } else if (subDupType.value === "N") {
          for (let index = 0; index < suganglist.value.length; index++) {
            const sugangItem = suganglist.value[index];
            const { idxItmSugangClass: standardItmSugangClass, isActivate } =
              sugangItem;

            if (
              standardItmSugangClass === idxItmSugangClass &&
              isActivate &&
              !sugangItem["checked"]
            ) {
              sugangItem["isUse"] = !checked;
            }
          }
        }
      }
    };

    //선택된 카드가 중복 타입에 따라 활성화 비활성화 처리
    const onChangeClass = (val) => {
      const { checked, idxItmSugangClass, subjectIdx } = val;
      
      if (subDupType.value === "O") {
        for (let index = 0; index < suganglist.value.length; index++) {
          const sugangItem = suganglist.value[index];
          const { idxItmSugangClass: standardItmSugangClass, isActivate } =
            sugangItem;

          if (
            standardItmSugangClass !== idxItmSugangClass &&
            isActivate &&
            !sugangItem["checked"]
          ) {
            sugangItem["isUse"] = !checked;
          }
        }
      } else if (subDupType.value === "X") {
        for (let index = 0; index < suganglist.value.length; index++) {
          const sugangItem = suganglist.value[index];
          const { subjectIdx: standardSubjectIdx, isActivate } = sugangItem;

          if (
            subjectIdx !== standardSubjectIdx &&
            isActivate &&
            !sugangItem["checked"]
          ) {
            sugangItem["isUse"] = !checked;
          }
        }
      } else if (subDupType.value === "N") {
        for (let index = 0; index < suganglist.value.length; index++) {
          const sugangItem = suganglist.value[index];
          const { idxItmSugangClass: standardItmSugangClass, isActivate } =
            sugangItem;
            
          if (standardItmSugangClass === idxItmSugangClass &&
            isActivate &&
            !sugangItem["checked"]
          ) {
            sugangItem["isUse"] = !checked;
          }
        }

        
        checkBoxCheckNum = 0;
        for (const item of suganglist.value) {
          if(item.checked) {
            checkBoxCheckNum++; 
          }
        }
        console.log(`checkBoxCheckNum = ${checkBoxCheckNum}`);
        if ( checked && props.program.subject_dup_type_n_limit != 0 && props.program.subject_dup_type_n_limit < checkBoxCheckNum + props.studentSugangList.filter(item => item.delStatus === "N").length){
            alert("최대 신청 가능 개수는 "+props.program.subject_dup_type_n_limit +" 개 입니다");
            console.log(suganglist.value)
            for (const item of suganglist.value) {
              if (item.subjectIdx === val.subjectIdx){
                item.checked = false;
              }
              if (item.idxItmSugangClass === val.idxItmSugangClass){
                item.isUse = true
              }
            }
            return false;
        }
      }
      context.emit("selectItem", val);
    };

    //선택된 수업 체크
    const subjectChecked = () => {
      for (let index = 0; index < suganglist.value.length; index++) {
        const { subjectIdx } = suganglist.value[index];
        const find = props.selectList.find(
          (selectItem) => selectItem["subjectIdx"] === subjectIdx
        );
        if (find) {
          suganglist.value[index]["checked"] = true;
        }
      }
    };

    const clickDetail = (val) => {
      //
      const { descList } = val;
      classDetailInfo.value = descList;
      classInfoModal.value = true;
    };

    const onClonseModal = () => {
      classInfoModal.value = false;
    };

    const compIsWaitShow = computed(() => {
      const { limit_way, wait_YN } = props.mainInfo;

      return limit_way === "P" && wait_YN === "Y" ? true : false;
    });

    watch(
      () => [
        _.cloneDeep(props.sugangList),
        _.cloneDeep(props.studentSugangList),
        _.cloneDeep(props.mainInfo),
        _.cloneDeep(props.program),
      ],
      ([cur1, cur2, cur3, cur4]) => {
        if (cur1 && cur2 && cur3 && cur4) {
          //수강리스트 초기화
          initSugangList(cur1);

          //나의 수업 제외
          exceptMyClass(cur2);

          //프로그램별 선착순 제한 체크
          programLimitOption();

          //신청자수 체크
          applyLimitOption();

          //프로그램 정보 세팅
          setProgrmaInfo();

          //선택된 수업 체크
          subjectChecked();

          //클래스 변경될때 마다 중복타입 확인 후 활성화/비활성화
          setDupType();
        }
      }
    );

    return {
      selectModel,
      selectIndex,
      suganglist,
      dispatchAction,
      compClassList,
      subDupType,
      onChangeClass,
      classInfoModal,
      classDetailInfo,
      clickDetail,
      onClonseModal,
      compIsWaitShow,

      isWaitInfo,
      checkBoxCheckNum
    };
  },
};
</script>
<style lang="scss">
.learning-wrapper {
  .multiselect__content-wrapper {
    top: 60px !important;
    border-radius: 8px;
    border: 1px solid #e7e7e7 !important;
    max-height: 300px !important;
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background-color: #eee;
    color: #000;
  }

  .multiselect__option--highlight {
    background-color: #eee;
    color: #000;
  }

  .multiselect__content-wrapper::-webkit-scrollbar {
    width: 2px;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background-color: #000;
  }
  .multiselect__content-wrapper::-webkit-scrollbar-track {
    background-color: #cdcdcd;
  }
  .multiselect__tags {
    border: 1px solid #959595;
    color: $black;
  }

  .multiselect__option {
    min-height: 21px;
    padding: 5px;
    border-bottom: 1px solid #eee;
  }
}
</style>
<style lang="scss" scoped>
.learning-wrapper {
  margin-bottom: 74px;

  .text-wrapper {
    margin-bottom: 26px;

    .title {
      font-size: 24px;
      font-weight: $bold;
      margin-bottom: 12px;

      .apply-cnt {
        font-size: 17px;
        color: #575757;
      }
    }

    .sub {
      font-size: 17px;
      color: #575757;

      span {
        font-weight: $bold;
      }

      li:first-child {
        margin-bottom: 5px;
      }
    }
  }

  .select-wrapper {
    display: flex;
    align-items: center;
    gap: 0 18px;
    margin-bottom: 30px;

    .select {
      position: relative;
      width: 262px;

      div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 16px;
        border: solid 1px #959595;
        border-radius: 8px;
        cursor: pointer;

        p {
          font-size: 15px;
          font-weight: $bold;
        }
      }

      .list-item {
        top: 45px;
        border: none;
      }

      ul {
        position: absolute;
        top: 45px;
        width: 100%;
        max-height: 200px;
        background: $white;
        border-radius: 8px;
        box-shadow: 3.6px 1.8px 40px 0 rgba(0, 0, 0, 0.13);
        overflow-y: scroll;
        padding: 0 17px;

        li {
          padding: 12px 5px;
          border-bottom: 1px solid $gray-e7e7e7;
          cursor: pointer;

          &:last-child {
            border-bottom: 0 none;
          }
        }
      }
    }

    .warn {
      font-size: 13px;
      color: $red;

      span {
        font-size: 5px;
      }
    }
  }

  .list-wrapper {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
    border-radius: 14px;
    background-color: $gary-f6f7f8;
    padding: 26px;

    li {
      width: calc(100% - 68%);
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      border: solid 1px #959595;
      border-radius: 8px;
      overflow: hidden;

      .top-con {
        padding: 14px 24px;
        background-color: #edf0f3;

        input.select-check {
          -webkit-appearance: none;
          -moz-appearance: none;
          -o-appearance: none;
          appearance: none;
          outline: none;
          box-shadow: none;
          width: 18px;
          height: 18px;
          border: solid 1px #656565;
          background-color: #fff;
          border-radius: 12px;
        }

        input.select-check:checked {
          background: url("../../assets/imgs/common/check_white.png") no-repeat
            $blue;
          background-size: 10px;
          background-position-x: 3px;
          background-position-y: 4px;
          border: solid 1px $blue;
        }

        > p:first-child {
          font-size: 18px;
          font-weight: $medium;
          color: #4c4c4c;
          margin-bottom: 10px;
        }

        .select-btn-default,
        .select-btn-red {
          font-size: 14px;
          height: 30px;
          padding: 5px 5px;
          border-radius: 19px;
          margin-right: 8px;
        }

        .select-btn-default {
          background-color: #d4d4d4c4;
        }

        .select-btn-red {
          color: #ff3737;
          background-color: #ffe5e5;
        }

        .select-text {
          font-size: 16px;
          margin-left: 25px;
          padding-right: 20px;
          line-height: 1.5;
          letter-spacing: -0.64px;
        }

        .class-detail{
          display: flex;
          justify-content: space-between;
          align-items: center;

          > div{
            display: flex;
            align-items: center;
            gap: 4px;
          }

          > p {
            font-size: 15px;
            font-weight: $medium;
            color: $blue;
            cursor: pointer;
          }
        }

      }

      .bottom-con {
        font-size: 15px;
        color: #8a8a8a;
        padding: 16px 24px;
        height: 100%;
        background-color: $white;
      }

      &.on {
        border: solid 1px $blue;

        .top-con {
          background-color: #d2e4ff;

          p:first-child {
            color: $black;
            font-weight: $bold;
          }
        }

        .bottom-con {
          color: $black;
        }
      }
    }
  }
}
</style>
